// extracted by mini-css-extract-plugin
export default {"imageWrapper":"PreviewGroupImage_imageWrapper__orXC9","image":"PreviewGroupImage_image__FpN6P"};